import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import SectionLayout from "reusables/layouts/SectionLayout";

import screenLogin from "assets/images/WorkforceApp/screen_login.png";
import screenHome from "assets/images/WorkforceApp/screen_home.png";
import screenClockIn from "assets/images/WorkforceApp/screen_clockin.png";
import screenClockedIn from "assets/images/WorkforceApp/phoneImage.png";
import screenSchedule from "assets/images/WorkforceApp/screen_schedule_today.png";
import screenAlerts from "assets/images/WorkforceApp/screen_alerts.png";

const steps = [
  {
    step: "01",
    image: screenLogin,
    title: "Company Signs Up",
    description:
      "Your company gets set up on Spechs Workforce. An administrator account is created and your settings are configured.",
  },
  {
    step: "02",
    image: screenHome,
    title: "Invite Your Team",
    description:
      "Invite managers and staff via email. Each user receives credentials and sets their own password on first login.",
  },
  {
    step: "03",
    image: screenSchedule,
    title: "Create Jobs & Schedules",
    description:
      "Set up one-time jobs or recurring schedules with location and time details. Assign to managers or directly to staff.",
  },
  {
    step: "04",
    image: screenClockIn,
    title: "Workers Clock In via App",
    description:
      "Staff open the mobile app, see their assigned jobs, and clock in with a tap. GPS location is captured automatically.",
  },
  {
    step: "05",
    image: screenAlerts,
    title: "Review & Approve",
    description:
      "Time entries within the grace period are auto-approved. Managers review flagged entries from the web dashboard.",
  },
  {
    step: "06",
    image: screenClockedIn,
    title: "Payroll Ready",
    description:
      "All approved hours, rates, and deductions are calculated automatically. Export reports for your payroll process.",
  },
];

function HowItWorks() {
  return (
    <SectionLayout
      mt={20}
      title="How It Works"
      description="From sign-up to payroll — Spechs Workforce is designed to be up and running in minutes."
      contents={
        <Container>
          <Grid container spacing={4} sx={{ mt: 2 }}>
            {steps.map(({ step, image, title, description }) => (
              <Grid item xs={12} sm={6} lg={4} key={step}>
                <MKBox
                  sx={{
                    background: "white",
                    borderRadius: 3,
                    border: "1px solid #e9ecef",
                    overflow: "hidden",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    transition: "box-shadow 0.25s ease",
                    "&:hover": { boxShadow: "0 12px 40px rgba(0,0,0,0.1)" },
                  }}
                >
                  {/* Screenshot */}
                  <MKBox
                    sx={{
                      background: "#f8f9fa",
                      display: "flex",
                      justifyContent: "center",
                      pt: 3,
                      pb: 1,
                      px: 4,
                    }}
                  >
                    <MKBox
                      component="img"
                      src={image}
                      alt={title}
                      sx={{
                        width: "60%",
                        borderRadius: 3,
                        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                      }}
                    />
                  </MKBox>

                  {/* Text */}
                  <MKBox p={3} sx={{ flex: 1 }}>
                    <MKTypography
                      variant="caption"
                      sx={{
                        color: "#adb5bd",
                        fontWeight: 700,
                        letterSpacing: "0.08em",
                        display: "block",
                        mb: 0.5,
                      }}
                    >
                      STEP {step}
                    </MKTypography>
                    <MKTypography variant="h6" fontWeight="bold" sx={{ color: "#32373c", mb: 1 }}>
                      {title}
                    </MKTypography>
                    <MKTypography variant="body2" sx={{ color: "#6c757d", lineHeight: 1.7 }}>
                      {description}
                    </MKTypography>
                  </MKBox>
                </MKBox>
              </Grid>
            ))}
          </Grid>
        </Container>
      }
    />
  );
}

export default HowItWorks;
